import { render, staticRenderFns } from "./CedisSales.vue?vue&type=template&id=65a2335a"
import script from "./CedisSales.vue?vue&type=script&lang=js"
export * from "./CedisSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports